export default __webpack_public_path__ + "static/media/MemberShipNew.3889f7c9.svg";